import React from "react";
import SignIn from "./signin";
import '../../styles/login.css'

const Login = (props) => {
    return (
        <div className="body text-center">
            <SignIn { ...props } />
        </div>
    )
}

export default Login;